import { isUndefined } from './lib';

export const isLowerThanMin = (min, value) => (!min || value < min);
export const isHigherThanMax = (max, value) => (!max || value > max);
export const isBetween = (min, max, value) => (!max || value <= max) && (!min || value >= min);
export const isDirty = (value) => !isUndefined(value) && value !== null && value !== '';
